import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from "react";
import { AnimatedCircle } from "@/components/atoms/AnimatedCircle";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
type Props = {
  description: string;
  hasGoUpButton?: boolean;
  compact?: boolean;
  hideExpand?: boolean;
};

/** True when the description has real content to render (not blank or a
 *  stringified null/undefined). Mirrors the guard inside the component so
 *  callers can hide the surrounding heading/card. */
export function hasRenderableDescription(description?: string | null): boolean {
  const text = description?.trim();
  return !!text && text !== "undefined" && text !== "null";
}
export default function RealEstateDescriptionText(t0) {
  const $ = _c(35);
  const {
    description,
    hasGoUpButton,
    compact,
    hideExpand
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [measuredHeight, setMeasuredHeight] = useState();
  const contentRef = useRef(null);
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== hideExpand) {
    t1 = () => {
      if (hideExpand) {
        setIsOverflowing(false);
        return;
      }
      if (contentRef.current) {
        const fullHeight = contentRef.current.scrollHeight;
        setMeasuredHeight(fullHeight);
        setIsOverflowing(fullHeight > 240);
      }
    };
    $[0] = hideExpand;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description || $[3] !== hideExpand) {
    t2 = [description, hideExpand];
    $[2] = description;
    $[3] = hideExpand;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== description) {
    t3 = description?.trim();
    $[5] = description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const text = t3;
  if (!hasRenderableDescription(description)) {
    return null;
  }
  const showExpand = isOverflowing && !hideExpand;
  const truncate = !hideExpand && !isExpanded;
  const t4 = showExpand && isMobile ? "mb-10" : "";
  let t5;
  if ($[7] !== t4) {
    t5 = cn("relative", t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = compact ? "mt-4" : "mt-2 md:mt-3";
  const t7 = showExpand && "transition-all duration-500";
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = cn("relative overflow-hidden", t6, t7);
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = hideExpand ? "auto" : isExpanded ? measuredHeight ?? "auto" : Math.min(240, measuredHeight ?? 240);
  let t10;
  if ($[12] !== t9) {
    t10 = {
      height: t9
    };
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== truncate) {
    t11 = truncate ? {
      display: "-webkit-box",
      WebkitLineClamp: 15,
      WebkitBoxOrient: "vertical",
      overflow: "hidden"
    } : {};
    $[14] = truncate;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== text) {
    t12 = <p ref={contentRef} className="text-foreground-heading whitespace-pre-line" style={t11}>{text}</p>;
    $[16] = t11;
    $[17] = text;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== isExpanded || $[20] !== showExpand) {
    t13 = showExpand && !isExpanded && <div className="pointer-events-none absolute left-0 right-0 bottom-0 h-16 bg-linear-to-t from-background to-transparent" />;
    $[19] = isExpanded;
    $[20] = showExpand;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t12 || $[24] !== t13 || $[25] !== t8) {
    t14 = <div className={t8} style={t10}>{t12}{t13}</div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
    $[25] = t8;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== hasGoUpButton || $[28] !== isExpanded || $[29] !== showExpand) {
    t15 = showExpand && <div className={cn("absolute left-1/2 transform -bottom-12 md:-bottom-4 -translate-x-1/2 cursor-pointer w-full flex justify-center")} onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? hasGoUpButton ? <div><AnimatedCircle inverted={true} /></div> : null : <AnimatedCircle />}</div>;
    $[27] = hasGoUpButton;
    $[28] = isExpanded;
    $[29] = showExpand;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15 || $[33] !== t5) {
    t16 = <div className={t5} data-sentry-component="RealEstateDescriptionText" data-sentry-source-file="RealEstateDescriptionText.tsx">{t14}{t15}</div>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t5;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}